const postData = (url, data, successCallBack, errorCallBack, get) => {
    const requestOptions = (get) ? {
        method: 'GET'
    } : {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    }

    window.fetch(url, requestOptions)
        .then((response) => {
            if (response.redirected) {
                //captures redirect url, replaces query string and forwards browser
                let redirectUrl = response.url.split('?')[0];
                redirectUrl += `?returnurl=${window.location.href}`;
                window.location.href = redirectUrl;
                return false;
            }

            if (!response.ok) {
                // check if bad request, validation error
                if (response.status === 400) {
                    return response.text().then((result) => {
                        let resultData = '';
                        if (result && result.length) {
                            try {
                                //check if response is JSON
                                resultData = JSON.parse(result);
                            } catch (err) {
                                //not JSON, process text
                                console.log(result);
                                resultData = result;
                            }
                        }
                        if (errorCallBack &&
                            Object.prototype.toString.call(errorCallBack) === '[object Function]') {
                            if (resultData.errors !== undefined) {
                                errorCallBack(resultData.errors);
                            } else {
                                errorCallBack(resultData);
                            }
                        }
                    });
                } else {
                    return response.text().then((text) => { throw text; });
                }
            }

            //good result

            //if pdf, download and open in new tab
            if (response.headers.get('Content-Type') === 'application/pdf') {
                return response.blob().then((blob) => {
                    var file = window.URL.createObjectURL(blob);
                    window.open(file, '_blank');

                    //check if callBack function was provided and if so, execute function
                    if (successCallBack &&
                        Object.prototype.toString.call(successCallBack) === '[object Function]') {
                        successCallBack();
                    }
                });
            }

            //if csv, download and open in new tab
            if (response.headers.get('Content-Type') === 'text/csv') {
                let filename = 'download.txt';
                const dispositionHeader = response.headers.get('content-disposition');
                if (dispositionHeader && dispositionHeader.indexOf('attachment') !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(dispositionHeader);
                    if (matches !== null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                }
                return response.blob().then((blob) => {
                    const href = window.URL.createObjectURL(blob);
                    const anchor = document.createElement('a');
                    anchor.style.display = 'none';
                    anchor.href = href;
                    anchor.setAttribute('download', filename);
                    document.body.appendChild(anchor);
                    anchor.click();
                    document.body.removeChild(anchor);

                    //check if callBack function was provided and if so, execute function
                    if (successCallBack &&
                        Object.prototype.toString.call(successCallBack) === '[object Function]') {
                        successCallBack();
                    }
                });
            }

            //other response
            return response.text().then((result) => {
                let resultData = '';

                if (result && result.length) {
                    //check if result was json or html. If html, open new window and display html
                    //this is handy for returning html reports that open in new window
                    switch (response.headers.get('Content-Type')) {
                        case 'text/html; charset=utf-8':
                            var tab = window.open('', '');
                            tab.document.write(result);
                            tab.document.close(); //closes the write action, not the tab
                            break;
                        case 'application/json; charset=utf-8':
                            resultData = JSON.parse(result);
                            break;
                    }
                }

                //check if callBack function was provided and if so, execute function
                if (successCallBack &&
                    Object.prototype.toString.call(successCallBack) === '[object Function]') {
                    successCallBack(resultData);
                }
            });

        }).catch((error) => {
            console.log(error);
        });
};

export default postData;